export default __webpack_public_path__ + "images/bf5b011a884dde3675a7b84e69de3b5a-swimming-pool.png";